import { QueryParameters } from '@deck.gl/carto'
import { sendSQLPostRequest } from './sql'
import { getClient } from 'features/common/utils/clientParameter'

interface GetSQLQueryInfoProps {
  query: string
  queryParameters: QueryParameters | null | undefined
  connectionId: string
}

export function getSQLQueryInfo({ query, queryParameters, connectionId }: GetSQLQueryInfoProps) {
  return {
    queryKey: ['query', query, connectionId],
    queryFn: () => {
      return sendSQLPostRequest({
        connection: connectionId,
        query,
        queryParameters: queryParameters ?? undefined,
        extraParams: { dryRun: true, client: getClient() }
      })
    }
  }
}
